package org.tlsys.api.core2

object Files {
    const val DOWNLOAD = "/capi/v1/download/"
}
